import { Injectable, inject } from '@angular/core';
import { take } from 'rxjs';
import { UiQuery } from './ui.query';
import { UiArea } from './ui.models';
import { ConfirmationModalComponent } from '../../components';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationModalCloseType } from '../../../models';
import { UiStore } from './ui.store';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  private readonly _dialogService = inject(DialogService);
  private readonly _uiQuery = inject(UiQuery);
  private readonly _uiStore = inject(UiStore);

  private _confirmationModalCloseType = ConfirmationModalCloseType;

  showUnsavedChangesModalIfNeeded(areaId: UiArea, acceptAction?: any, rejectAction?: any, dismissViaXAction?: any) {
    this._uiQuery
      .select()
      .pipe(take(1))
      .subscribe((ui) => {
        if (ui.isUnsavedChangesModalNeeded && ui.unsavedChangesAreaId === areaId) {
          const dialogRef = this._dialogService.open(ConfirmationModalComponent, {
            closable: true,
            width: '450px',
            data: {
              message: ui.unsavedChangesMessage,
              header: 'Unsaved Changes',
              icon: 'pi pi-save',
              acceptLabel: ui.unsavedChangesAcceptLabel,
              rejectLabel: ui.unsavedChangesRejectLabel,
            },
          });

          dialogRef.onClose.subscribe((modalResult: ConfirmationModalCloseType) => {
            if (modalResult === this._confirmationModalCloseType.ClosedViaAcceptButton) {
              if (acceptAction) {
                acceptAction();
              }
            } else if (modalResult === this._confirmationModalCloseType.ClosedViaRejectButton) {
              if (rejectAction) {
                rejectAction();
              }
              this._uiStore.resetUnsavedChanges();
            } else if (dismissViaXAction) {
              dismissViaXAction();
            }
          });
        } else if (acceptAction) {
          acceptAction();
        }
      });
  }
}
